export type Range = [number | null, number | null]

export type DateRange = [string | null, string | null]

export type Coordinates = {
  lat: number
  long: number
}

export type DistanceRange = {
  distance: number | null
  zipCode: string | null
  coordinates: Coordinates | null
}

export const isDistanceRange = (value: unknown): value is DistanceRange => {
  if (typeof value !== 'object' || value === null) return false

  const obj = value as Record<string, unknown>

  return (
    (obj.distance === null || typeof obj.distance === 'number') &&
    (obj.zipCode === null || typeof obj.zipCode === 'string') &&
    (obj.coordinates === null ||
      (typeof obj.coordinates === 'object' &&
        'lat' in obj.coordinates &&
        typeof obj.coordinates.lat === 'number' &&
        'long' in obj.coordinates &&
        typeof obj.coordinates.long === 'number'))
  )
}
